import { Brick, registerBrick } from 'olympe';

export default class RGGetChangeProperties extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!RGChange} change
     * @param {function(!Object|!CloudObject)} setObject
     * @param {function(!Object|!CloudObject)} setProperty
     * @param {function(!*)} setNewValue
     * @param {function(!*)} setOldValue
     */
    update(_$, [change], [setObject, setProperty, setNewValue, setOldValue]) {
        setObject(change.object);
        setProperty(change.property);
        setNewValue(change.newValue);
        setOldValue(change.oldValue);
    }
}

registerBrick('0192055d7857bd08279c', RGGetChangeProperties);
